import { Stat } from "./Panel"

interface TelemetryReadoutProps {
  reading: {
    t?: number
    altitude?: number
    speed?: number
    fuel?: number
    throttle?: number
    vx?: number
    vy?: number
    vz?: number
    tilt?: number
  } | null
}

export function TelemetryReadout({ reading }: TelemetryReadoutProps) {
  const row = (label: string, value: number | undefined, unit: string, accent: "cyan" | "blue" | "amber") => (
    <Stat key={label} label={label} value={value != null ? value.toFixed(2) : "—"} unit={unit} accent={accent} />
  )

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
      {row("MET", reading?.t, "s", "cyan")}
      {row("ALTITUDE", reading?.altitude, "m", "cyan")}
      {row("SPEED", reading?.speed, "m/s", "blue")}
      {row("FUEL", reading?.fuel, "kg", "amber")}
      {row("VX", reading?.vx, "m/s", "blue")}
      {row("VY", reading?.vy, "m/s", "blue")}
      {row("VZ", reading?.vz, "m/s", "blue")}
      {row("THROTTLE", reading?.throttle != null ? reading.throttle * 100 : undefined, "%", "amber")}
    </div>
  )
}
